<template>
  <div class="promotion-center pk-account-panel">
    <section class="promotion-hero">
      <div>
        <span>平台活动</span>
        <h1>活动中心</h1>
        <p>宣传平台内最新活动及玩法，活动内容最终解释权由 PizzaKing-CJ 所有！</p>
      </div>
      <img src="/img/pizzaking/columns/activity.png" alt="" />
    </section>

    <section class="promotion-summary">
      <article><span>当前活动</span><strong>{{ slots.length }}</strong><em>进行中</em></article>
      <article><span>活动入口</span><strong>统一</strong><em>活动专区</em></article>
      <article><span>合作咨询</span><strong>站内</strong><em>支持中心工单反馈</em></article>
    </section>

    <section class="promotion-board">
      <header>
        <div><span>进行中的活动</span><h2>正在进行</h2></div>
        <button @click="goCooperation">客服中心</button>
      </header>
      <div v-if="slots.length" class="promotion-grid">
        <article
          v-for="slot in slots"
          :key="slot.id || slot.slot_key"
          class="promotion-card"
          role="button"
          tabindex="0"
          @click="openSlot(slot)"
          @keyup.enter="openSlot(slot)"
        >
          <div class="promotion-art">
            <img :src="slot.image_url || fallbackImage" alt="" @error="useFallback" />
            <span>{{ slot.slot_key === 'bonus_ad' ? 'RECHARGE' : 'EVENT' }}</span>
          </div>
          <div class="promotion-copy">
            <strong>{{ slot.title }}</strong>
            <p>{{ slot.subtitle || '平台活动详情请点击查看。' }}</p>
            <button @click.stop="openSlot(slot)">{{ slot.button_text || '查看活动' }}</button>
          </div>
        </article>
      </div>
      <div v-else class="promotion-empty">
        <img :src="fallbackImage" alt="" />
        <strong>暂未开启活动</strong>
        <p>暂无活动</p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PromotionCenter',
  data() {
    return {
      slots: [],
      fallbackImage: '/img/pizzaking/columns/activity.png',
    };
  },
  mounted() {
    this.loadSlots();
  },
  methods: {
    loadSlots() {
      this.$axios.post('/index/Setting/promotionSlots').then((res) => {
        if (res.data.status == 1) this.slots = (res.data.data || []).filter((slot) => Number(slot.enabled) === 1);
      });
    },
    useFallback(event) {
      event.target.src = this.fallbackImage;
    },
    openSlot(slot) {
      if (!slot.target_url) return;
      if (/^https?:\/\//i.test(slot.target_url)) {
        window.open(slot.target_url, '_blank');
        return;
      }
      this.go(slot.target_url);
    },
    go(path) {
      this.$router.push({ path });
    },
    goCooperation() {
      this.$router.push({ path: '/Doubt', query: { category: 'cooperation' } });
    },
  },
};
</script>

<style lang="less" scoped>
.promotion-center { min-height: calc(100vh - 198px); padding: 34px 34px 90px; color: #f7f3e9; background: radial-gradient(circle at 76% 4%, rgba(255, 120, 28, .24), transparent 28%), linear-gradient(180deg, #20222e, #171923); }
.promotion-hero, .promotion-summary, .promotion-board { max-width: 1540px; margin: 0 auto; }
.promotion-hero { min-height: 310px; padding: 44px 58px; display: flex; align-items: center; justify-content: space-between; overflow: hidden; border: 1px solid rgba(255, 145, 42, .32); border-radius: 18px; background: linear-gradient(118deg, rgba(41, 38, 44, .98), rgba(24, 26, 36, .94)); box-shadow: 0 24px 70px rgba(0, 0, 0, .28); }
.promotion-hero span, .promotion-board header span { color: #ff9d2a; font-size: 12px; font-weight: 900; letter-spacing: .18em; }
.promotion-hero h1 { margin: 14px 0; font-size: 64px; line-height: 1; }
.promotion-hero p { max-width: 650px; color: #bbb8c5; line-height: 1.8; font-weight: 700; }
.promotion-hero img { width: 280px; filter: drop-shadow(0 20px 30px rgba(255, 118, 22, .35)); animation: rise 4s ease-in-out infinite; }
.promotion-summary { margin-top: 22px; display: grid; grid-template-columns: repeat(3, 1fr); gap: 14px; }
.promotion-summary article { padding: 22px; border: 1px solid #353847; border-radius: 12px; background: rgba(39, 42, 56, .86); }
.promotion-summary span, .promotion-summary em { display: block; color: #a8adba; font-size: 13px; font-style: normal; }
.promotion-summary strong { display: block; margin: 9px 0 5px; color: #ffd67c; font-size: 28px; }
.promotion-board { margin-top: 24px; padding: 26px; border: 1px solid #353847; border-radius: 16px; background: rgba(31, 33, 45, .92); }
.promotion-board header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 22px; }
.promotion-board h2 { margin: 8px 0 0; font-size: 26px; }
.promotion-board header button, .promotion-copy button { border: 0; border-radius: 7px; color: #25160c; background: linear-gradient(180deg, #ffd67c, #ff8d20); font-weight: 900; cursor: pointer; }
.promotion-board header button { height: 40px; padding: 0 18px; }
.promotion-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 16px; }
.promotion-card { overflow: hidden; border: 1px solid #3a3c4d; border-radius: 12px; background: #272a38; cursor: pointer; transition: transform .2s ease, border-color .2s ease, box-shadow .2s ease; }
.promotion-card:hover, .promotion-card:focus { transform: translateY(-3px); border-color: rgba(255, 173, 65, .72); box-shadow: 0 14px 32px rgba(0, 0, 0, .26), 0 0 22px rgba(255, 141, 32, .12); outline: 0; }
.promotion-art { height: 165px; position: relative; display: grid; place-items: center; overflow: hidden; background: radial-gradient(circle, rgba(255, 142, 28, .22), transparent 62%); }
.promotion-art img { max-width: 72%; max-height: 145px; object-fit: contain; }
.promotion-art span { position: absolute; left: 14px; top: 14px; color: #ffbc54; font-size: 11px; font-weight: 900; letter-spacing: .12em; }
.promotion-copy { padding: 17px; }
.promotion-copy strong { display: block; font-size: 18px; }
.promotion-copy p { min-height: 42px; margin: 8px 0 15px; color: #aeb3c1; line-height: 1.5; }
.promotion-copy button { height: 36px; padding: 0 15px; }
.promotion-empty { padding: 54px 20px; text-align: center; color: #aeb3c1; }
.promotion-empty img { width: 120px; opacity: .72; }
.promotion-empty strong { display: block; margin-top: 8px; color: #f5f6ff; }
@keyframes rise { 50% { transform: translateY(-10px) rotate(-2deg); } }
@media (max-width: 900px) { .promotion-center { padding: 20px 16px 54px; } .promotion-hero { min-height: 0; padding: 32px; } .promotion-hero h1 { font-size: 42px; } .promotion-hero img { width: 150px; } .promotion-grid { grid-template-columns: 1fr; } }
</style>
